export enum SEARCH_INPUT_TYPES {
  PRIMARY = 'primary',
  GLOBAL = 'global',
  BORDERED = 'bordered',
}
